import React from 'react';

const TermsConditionsBanner = () =>{
    return (
        <>
        <div className='cadTerms-conditionBanner cadModelingMain cadAboutBanner cadContactBanner'>
            <img 
            src="/assets/terms-conditions-banner.webp"
            alt="t&C-banner" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1>Terms <span>&</span> Conditions</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default TermsConditionsBanner;